import { render, staticRenderFns } from "./BasePopMenu.vue?vue&type=template&id=651a214e&scoped=true&"
import script from "./BasePopMenu.vue?vue&type=script&lang=js&"
export * from "./BasePopMenu.vue?vue&type=script&lang=js&"
import style0 from "./BasePopMenu.vue?vue&type=style&index=0&id=651a214e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651a214e",
  null
  
)

export default component.exports